import React from 'react';
import PropTypes from 'prop-types';

import { trans, withClientConfig } from '@spotahome/soyuz/client';

import LoginSignUpModal from '../../../common/components/login/LoginModal';
import withModalHandle from '../../../common/components/withModalHandle';

import './FavoriteMessage.scss';

const FavoriteMessageLogged = ({
  handleModalOpen,
  handleModalClose,
  isModalOpen,
  clientConfig
}) =>
  clientConfig.featureToggle.login ? (
    <div>
      <p
        onClick={handleModalOpen}
        dangerouslySetInnerHTML={{
          __html: trans('favorites.message.top.not_logged')
        }}
        className="favorites--message ga-favorites-page-explore-button"
      />
      <LoginSignUpModal
        isOpen={isModalOpen}
        initialAction="signup"
        onClose={handleModalClose}
      />
    </div>
  ) : null;

FavoriteMessageLogged.propTypes = {
  handleModalOpen: PropTypes.func.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool.isRequired
};

export default withClientConfig()(withModalHandle()(FavoriteMessageLogged));
